import { utils } from '@hh/global.js'
const { updateCart } = utils

class GiftNote extends HTMLElement {
  constructor() {
    super()

    this.textarea = this.querySelector('textarea')
    this.charCount = this.querySelector('.js-char-count')
    this.submit = this.querySelector('.js-submit')
    this.remove = this.querySelector('.js-remove')

    this.giftNoteTextElement = document.querySelector('.js-gift-note-text')
    this.addCopyElement = document.querySelector(
      '.gift-note__trigger-text--add'
    )
    this.editCopyElement = document.querySelector(
      '.gift-note__trigger-text--edit'
    )
    this.iconElement = document.querySelector('.gift-note-trigger__icon')

    this.handleSubmit = this.handleSubmit.bind(this)

    this.textarea.addEventListener('input', this.handleInput.bind(this))
    this.textarea.addEventListener(
      'keydown',
      this.handleInputKeydown.bind(this)
    )
    this.submit.addEventListener('click', () => this.handleSubmit('submit'))
    this.remove.addEventListener('click', () => this.handleSubmit('remove'))

    this.updateTriggerCopy()
  }

  handleInput(e) {
    let value = e.target.value

    // Count lines and limit to 5
    const lines = value.split(/\r\n|\r|\n/)
    if (lines.length > 5) {
      // If more than 5 lines, keep only the first 5
      value = lines.slice(0, 5).join('\n')
      this.textarea.value = value
      // Move cursor to end
      this.textarea.setSelectionRange(value.length, value.length)
    }

    // Update character count
    this.charCount.innerHTML = value.length
    this.updateTriggerCopy()
  }

  handleInputKeydown(e) {
    if (e.key === 'Enter') {
      const currentValue = this.textarea.value
      const lines = currentValue.split(/\r\n|\r|\n/)

      // Prevent Enter if already at 5 lines
      if (lines.length >= 5) {
        e.preventDefault()
      }
    }
  }

  async handleSubmit(source) {
    if (source == 'remove') {
      this.textarea.value = ''
      this.charCount.innerHTML = 0
    }

    const body = {
      note: source == 'submit' ? this.textarea.value : '',
    }

    await updateCart(body)
    this.updateTriggerCopy()
    this.closest('hh-drawer').close()
  }

  updateTriggerCopy() {
    if (this.textarea.value.trim()) {
      this.addCopyElement.classList.remove('visible')
      this.editCopyElement.classList.add('visible')
      this.iconElement.classList.add('hidden')

      if (this.giftNoteTextElement) {
        this.giftNoteTextElement.textContent = this.textarea.value.trim()
        this.giftNoteTextElement.setAttribute(
          'data-gift-note-populated',
          'true'
        )
      }
    } else {
      this.addCopyElement.classList.add('visible')
      this.editCopyElement.classList.remove('visible')
      this.iconElement.classList.remove('hidden')

      if (this.giftNoteTextElement) {
        this.giftNoteTextElement.textContent = ''
        this.giftNoteTextElement.removeAttribute('data-gift-note-populated')
      }
    }
  }
}

customElements.define('hh-gift-note', GiftNote)
